import { plainText } from "constants/architectsTranslation";

function Plaintext({ text }: plainText) {
  return <p>{text}</p>;
}

export default Plaintext;
